import { type TemplateFilterBy } from '@heidi/schema/template-gallery';
import type { TemplateBasicInfo } from '@heidi/templates/contracts';
import { useIsCommunityDefaultFiltersEnabled } from '@heidi/templates/flags';
import RecommendedTemplatesNonEmpty from './recommendedTemplatesNonEmpty';
import TemplateCards from './templateCards';

interface RelatedTemplatesProps {
  directTemplates: TemplateBasicInfo[];
  recommendedTemplates: TemplateBasicInfo[];
  disabledFilters: TemplateFilterBy[];
  isLoading: boolean;
  isZeroResults: boolean;
}

const RelatedTemplates = ({
  directTemplates,
  recommendedTemplates,
  disabledFilters,
  isLoading,
  isZeroResults,
}: RelatedTemplatesProps) => {
  const isCommunityDefaultFiltersEnabled = useIsCommunityDefaultFiltersEnabled();
  const directTemplateIds = new Set(
    directTemplates.map((template) => template.template_id)
  );
  const templates = isCommunityDefaultFiltersEnabled
    ? recommendedTemplates.filter(
        (template) => !directTemplateIds.has(template.template_id)
      )
    : directTemplates.length === 0
      ? recommendedTemplates
      : [];

  if (isLoading || templates.length === 0) return null;

  return (
    <div className="flex w-full flex-col items-center gap-4">
      <RecommendedTemplatesNonEmpty
        disabledFilters={disabledFilters}
        isRelatedSection={isCommunityDefaultFiltersEnabled && !isZeroResults}
      />
      <TemplateCards templates={templates} isLoading={false} />
    </div>
  );
};

export default RelatedTemplates;
